import { baseUrl } from "../config/api";

const getBackColor = () => {
    // 本番環境
    if(baseUrl === "https://api.isi-campus.net/api/") return "#3a3e5d";
    // テスト環境
    else if(baseUrl === "https://cms-staging.ybs-inc.biz/api/") return "#8b4513";
    // ローカル環境
    else if(baseUrl === "http://signage-cms.local/api/") return "#8b4513";
    // デフォルト
    else return "#3a3e5d";
}

const getHoverColor = () => {
    // 本番環境
    if(baseUrl === "https://api.isi-campus.net/api/") return "#2a2935";
    // テスト環境
    else if(baseUrl === "https://cms-staging.ybs-inc.biz/api/") return "#622d18";
    // ローカル環境
    else if(baseUrl === "http://signage-cms.local/api/") return "#622d18";
    // デフォルト
    else return "#2a2935";
}

const colors = {
    text: "#4a4a4a",
    textLink: "#007aff",
    primary: "#3a3e5d",
    secondary: "#9290e1",
    caution: "#ff3442",
    black: "#202020",
    gray: "#949494",
    // caution2:  '#FF4C4C',
    bg: "#ffffff",
    bgHead: "#f4f4f4",
    // bgMenu:   '#3A3E5D',
    bgCaution: "#ffe3e3",
    border: "#daddde",
    navHover: "#2a2935",
    // rborder:    '#C9CBD3',
    selected: "#d3f1f8",
    // iconAlt:  '#FF76A8',
    backColor: getBackColor(),
    hoverColor: getHoverColor(),
};

export default colors;
